import VFocus from "./VFocus";
import VIntersection from "./VIntersection";

export default [VFocus, VIntersection];
